<template>
    <div v-if="display">
        <div class="add-person">
            <div class="col-sm-12">
                <span>Kliknite spodaj, če želite, da Helena izračuna kodo tudi za vašega družinskega člana (do 3 osebe) </span>

                <div class="additional_codes_buttons text-center">
                    <a v-if="count < 3" href="#" class="btn" v-on:click.prevent="add()">Dodaj dodatno osebo</a>
                    <a v-if="count > 0" href="#" class="btn" v-on:click.prevent="remove()">Odstrani osebo #{{this.count}}</a>
                </div>


            </div>
        </div>
    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect'

    Vue.component('multiselect', Multiselect)


    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "customer_schema", "payment_schema"],
        components: { Multiselect },
        data: function () {
            return {
                display: false,
                count: 0,
                yearsArray: []
            }
        },

        methods: {

            init: function () {
                this.generateYearsArray();

                this.model.customer.birthday_day = "";
                this.model.customer.birthday_month = "";
                this.model.customer.birthday_year = "";
                this.model.customer.birthday_hour = "";
                this.model.customer.birthday_minute = "";

                this.model.additional_codes = false;
                this.model.additional_codes_data = [];

                this.display = true;

                this.addCustomerBirthdayFields();

//                this.payment_schema.groups.push({
//                    legend: "Preverite podatke",
//                    fields: [
//                        {
//                            type: "dataConfirmation",
//                            label: "",
//                            styleClasses: 'col-sm-12',
//                        }
//                    ]
//                });

            },

            add: function () {
                this.model.additional_codes_data.push({
                    "first_name": "",
                    "last_name": "",
                    "birthday_day": "",
                    "birthday_month": "",
                    "birthday_year": "",
                    "birthday_hour": "",
                    "birthday_minute": "",
                });

                let fields = [{
                    type: "input",
                    inputType: "text",
                    label: "Ime",
                    model: this.getModelName("guest", "first_name"),
                    validator: VueFormGenerator.validators.string,
                    styleClasses: 'col-sm-6',
                    required: true
                },
                    {
                        type: "input",
                        inputType: "text",
                        label: "Priimek",
                        model: this.getModelName("guest", "last_name"),
                        validator: VueFormGenerator.validators.string,
                        styleClasses: 'col-sm-6',
                        required: true
                    },

                ];

                let birthdayFields = this.getBirthdayFields("guest");

                for (let i = 0; i < birthdayFields.length; i++) {
                    fields.push(birthdayFields[i]);
                }


                this.customer_schema.groups.push({
                    legend: "Dodatna oseba #" + (this.count + 1),
                    fields: fields
                });


                this.count++;

                this.model.quantity = this.count + 1;
                this.model.additional_codes = true;

                Event.$emit("prijavnica_update_totals");
            },

            addCustomerBirthdayFields: function () {
                let birthdayFields = this.getBirthdayFields("customer");
                this.customer_schema.groups.push({
                    legend: "Podatki o rojstvu",
                    fields: birthdayFields
                });

            },

            getBirthdayFields: function (type) {

                return [{
                    type: "vueMultiSelect",
                    multiSelect: false,
                    selectOptions: {
                        multiSelect: false,
                        closeOnSelect: true,
                        searchable: true,
                        showLabels: false
                    },
                    label: "Dan",
                    placeholder: "Izberite dan",
                    model: this.getModelName(type, "birthday_day"),
                    validator: VueFormGenerator.validators.required,
                    values: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31
                    ],
                    styleClasses: 'col-sm-4',
                    required: true
                },
                    {
                        type: "vueMultiSelect",
                        multiSelect: false,
                        selectOptions: {
                            multiSelect: false,
                            closeOnSelect: true,
                            searchable: true,
                            showLabels: false,

                        },
                        label: "Mesec",
                        placeholder: "Izberite mesec",
                        model: this.getModelName(type, "birthday_month"),
                        validator: VueFormGenerator.validators.required,
                        values:
                            function () {
                                return [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12
                                ]
                            }

                        ,
                        styleClasses: 'col-sm-4',
                        required: true,
                    },
                    {
                        type: "vueMultiSelect",
                        multiSelect: false,
                        selectOptions: {
                            multiSelect: false,
                            closeOnSelect: true,
                            searchable: true,
                            showLabels: false
                        },
                        label: "Leto",
                        placeholder: "Izberite leto",
                        model: this.getModelName(type, "birthday_year"),
                        validator: VueFormGenerator.validators.required,
                        values:

                            function () {
                                return this.yearsArray
                            }
                                .bind(this),
                        styleClasses: 'col-sm-4',
                        default: 1980,
                        required: true
                    },
                    {
                        type: "vueMultiSelect",
                        multiSelect: false,
                        selectOptions: {
                            multiSelect: false,
                            closeOnSelect: true,
                            searchable: true,
                            showLabels: false
                        },
                        label: "Ura",
                        placeholder: "Izberite uro",
                        model: this.getModelName(type, "birthday_hour"),
                        validator: VueFormGenerator.validators.required,
                        values:

                            function () {
                                return [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13,
                                    14,
                                    15,
                                    16,
                                    17,
                                    18,
                                    19,
                                    20,
                                    21,
                                    22,
                                    23,
                                ]
                            }

                        ,
                        styleClasses: 'col-sm-6',
                        required: true
                    },
                    {
                        type: "vueMultiSelect",
                        multiSelect: false,
                        selectOptions: {
                            multiSelect: false,
                            closeOnSelect: true,
                            searchable: true,
                            showLabels: false
                        },
                        label: "Minute",
                        placeholder: "Izberite minuto",
                        model: this.getModelName(type, "birthday_minute"),
                        validator: VueFormGenerator.validators.required,
                        values:

                            function () {
                                return [
                                    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59
                                ]
                            }

                        ,
                        styleClasses: 'col-sm-6',
                        required: true
                    }]

            },

            remove: function () {

                this.customer_schema.groups.splice(-1, 1);
                this.model.additional_codes_data.splice(-1.1);

                this.model.additional_codes = !! this.model.additional_codes_data.length ;

                this.count--;

                this.model.quantity = this.count + 1;

                Event.$emit("prijavnica_update_totals");
            },

            getModelName(type, name) {
                if (type === "customer") {
                    return "customer." + name;
                } else if (type === "guest") {
                    return "additional_codes_data." + this.count + "." + name;
                }
            },

            generateYearsArray() {
                let years = [];
                for (let i = 1930; i < 2000; i++) {
                    years.push(i);
                }
                this.yearsArray = years;
            }
        },


    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/DNACodes.vue